import { OPERATION_ERROR_STANDART, OPERATION_ERROR_FATAL } from './data_query';

export class OperationResult {

  private isError: boolean;
  private errorLevel: number = 0;

  private resultContent: any;
  private resultMeta: any;

  public static fromResponse(response: any): OperationResult {
    return new OperationResult(
      response.action,
      response.status,
      response.result,
    );
  }

  constructor(private action: string, private status: number, private rawResult: any) {
      switch (status) {
        case 200:
        case 201: {
          this.isError = false;

          switch (action) {
            // case 'create':
            // case 'update':
            // case 'get': {
            //   this.resultContent = plainToClass(DataObject, rawResult);
            //   break;
            // }
            // case 'schema_get': {
            //   this.resultContent = plainToClass(Schema, rawResult);
            //   break;
            // }
            // case 'schema_list': {
            //   this.resultContent = plainToClass(Schema, rawResult);
            //   break;
            // }
            // case 'list': {
            //   this.resultContent = plainToClass(DataObject, rawResult['elements']);
            //   this.resultMeta = rawResult['meta'];
            //   break;
            // }
            default: {
              this.resultContent = rawResult;
              break;
            }
          }
          // this.resultContent =
          break;
        }
        case 204: {
          this.isError = false;
          this.resultContent = true;
          break;
        }
        case 422: {
          this.isError = true;
          this.errorLevel = OPERATION_ERROR_STANDART;
          this.resultContent = rawResult;
          break;
        }
        default: {
          this.isError = true;
          this.errorLevel = OPERATION_ERROR_FATAL;
          break;
        }
      } // end switch
  }

  getContent(): any {
    return this.resultContent;
  }

  getMeta(): any {
    return this.resultMeta;
  }

  hasError(): boolean {
    return this.isError;
  }

  getErrorLevel() {
    return this.errorLevel;
  }
}
